var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "classesView" } },
    [
      _c(
        "v-overlay",
        { staticClass: "waitoverlay", attrs: { value: _vm.busy } },
        [
          _c("v-progress-circular", {
            staticClass: "mr-4",
            attrs: { indeterminate: "", size: "64" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "info-wrapper" },
        [
          _c("v-icon", { staticClass: "info-icon" }, [
            _vm._v("mdi-information-outline")
          ]),
          _c("span", { staticClass: "info-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("classes.banner-text")) + " ")
          ])
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8", md: "6" } },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("classes.your-classes")) + " "
                      ),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "text-sm-right",
                      attrs: { cols: "12", sm: "4", md: "6" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.createItemDialog }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("classes.new-class")) + " "
                          )
                        ]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "secondary",
                            "aria-label": _vm.$t("classes.refresh")
                          },
                          on: { click: _vm.refreshItems }
                        },
                        [_c("v-icon", [_vm._v("mdi-refresh")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "div",
                { staticClass: "searchBox" },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "mdi-magnify",
                      label: _vm.$t("global.search"),
                      "aria-label":
                        _vm.$t("global.text-field") +
                        " " +
                        _vm.$t("global.search") +
                        " " +
                        _vm.$t("classes.classes"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c("v-data-table", {
                attrs: {
                  filterable: "",
                  headers: _vm.headers.map(function(x) {
                    return Object.assign({}, x, { text: _vm.$t(x.text) })
                  }),
                  items: _vm.cleanItems,
                  "item-key": "id",
                  loading: _vm.loading,
                  search: _vm.search,
                  "items-per-page": 30,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "footer-props": {
                    "items-per-page-options": [15, 30, 50, 100, -1]
                  }
                },
                on: {
                  "update:sortBy": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function($event) {
                    _vm.sortDesc = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _vm.isOwner(item)
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  "aria-label":
                                                    _vm.$t("global.edit") +
                                                    " " +
                                                    _vm.$t(
                                                      "classes.classParam",
                                                      [item.displayName]
                                                    )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.editItem(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-pencil-outline ")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("edit")))])]
                        ),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _vm.isOwner(item)
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                attrs: {
                                                  "aria-label":
                                                    _vm.$t("global.delete") +
                                                    " " +
                                                    _vm.$t(
                                                      "classes.classParam",
                                                      [item.displayName]
                                                    )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteItem(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-delete-outline ")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("delete")))])]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.name",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c("a", { attrs: { href: _vm.createURL(item) } }, [
                          _vm._v(" " + _vm._s(item.name) + " ")
                        ])
                      ]
                    }
                  },
                  {
                    key: "item.creator",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(" " + _vm._s(item.creator.displayName) + " ")
                      ]
                    }
                  },
                  {
                    key: "item.content",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.contentDisplayName(item.content)) +
                            " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.created",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.displayTime(item.created)) + " "
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selected,
                  callback: function($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "600px", persistent: "" },
              model: {
                value: _vm.showEditDialog,
                callback: function($$v) {
                  _vm.showEditDialog = $$v
                },
                expression: "showEditDialog"
              }
            },
            [
              _c("class-edit", {
                attrs: {
                  model: _vm.editedItem,
                  editors: _vm.coaches,
                  content: _vm.content,
                  classes: _vm.items
                },
                on: { cancel: _vm.closeEditDialog, save: _vm.saveEditDialog }
              })
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showDeleteDialog,
                callback: function($$v) {
                  _vm.showDeleteDialog = $$v
                },
                expression: "showDeleteDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(_vm._s(_vm.$t("global.confirm")))
                  ]),
                  _c("v-card-text", [
                    _vm._v(_vm._s(_vm.$t("classes.confirm-delete")) + " "),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.selectedClassName))
                    ]),
                    _vm._v("?")
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue" },
                          on: { click: _vm.closeDeleteDialog }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.no")) + " ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red" },
                          on: { click: _vm.confirmDeleteItem }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.yes")) + " ")]
                      ),
                      _c("v-spacer")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-snackbar",
            {
              model: {
                value: _vm.error,
                callback: function($$v) {
                  _vm.error = $$v
                },
                expression: "error"
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: {
                    click: function($event) {
                      _vm.error = false
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.close")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }